import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import createDefaultActionDefinition from '../common/actionDefinition/default';

const fillAction = createDefaultActionDefinition(
  StylesDerivedNativeActions.fillStyles,
);

export default fillAction;
